var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mr-4 ml-4"},[_c('v-text-field',{attrs:{"label":_vm.$t(_vm.title) + '*',"error-messages":_vm.errorMessage,"disabled":_vm.disabled,"required":""},on:{"change":_vm.onChange,"blur":() => {
        this.wasBlurred = true;
      }},model:{value:(_vm.textData),callback:function ($$v) {_vm.textData=$$v},expression:"textData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }